export enum CustomerAddressTypeEnum {
  shipping = 1,
  billing = 2,
  return = 3
}
